import React, { Component } from "react";
import { websiteUrl } from '../../utils/common';

const HistoryPlayback = (props) => 
{ 
     var WEB_URL=websiteUrl();
     const strUrl=WEB_URL+`RouteHistoryPlayBack.html?IMEI=${props.Historyobj.IMEI}&FromDate=${props.Historyobj.fromDate}&ToDate=${props.Historyobj.toDate}`;
    
     return ( 
      <>                  
            <iframe width="100%" height="600px" src={strUrl}  title="History Playback" ></iframe>  
       </>       
       )}; 
   
export default HistoryPlayback;